import { ALL_CODES } from '../constants/menuResource';
import { getFieldMap } from '../constants/fieldResource';

export const MOCK_SUCCESS = {
  code: 0,
  message: "操作成功",
  data: {}
};

// ============ 串码资源 ============
const PLATFORMS = ['电信', '移动', '联通', '涂鸦'];
const MODELS = ['YLF-X1', 'YLF-G2', 'YLF-C3', 'YLF-T4'];
const MODEL_MAC_STEP = { 'YLF-X1': 2, 'YLF-G2': 1, 'YLF-C3': 3, 'YLF-T4': 1 };
const FACTORIES = ['达天', '凯木金', '中嘉'];
const ORDER_STATUS = ['待生产', '生产中', '已完成', '已关闭'];

// 各平台运营字段（sn 为通用串码编号，不在此处）
const genPlatformFields = (platform, index) => {
  const cei = `${String(860000000000001 + index)}`;
  const sn20 = `8600${String(index).padStart(16, '0')}`;
  switch (platform) {
    case '电信':
      return { CTEI: cei, UID: `UID${String(800000 + index)}`, KEY1: `KEY1${String(1000 + index)}`, KEY2: `KEY2${String(1000 + index)}` };
    case '联通':
      return { CUEI: cei };
    case '移动':
      return { CMEI: cei, SN: sn20, KEY: `KEY${String(1000 + index)}` };
    case '涂鸦':
      return { UID: `UID${String(800000 + index)}`, KEY: `KEY${String(1000 + index)}` };
    default:
      return {};
  }
};

// 串码状态变更记录（时间线）
const genSerialHistory = (status, index) => {
  const history = [{ action: '导入', time: "2026-08-19 10:00:00" }];
  if (status !== '未使用') {
    history.push({ action: '下发', time: `2026-08-2${index % 9} 14:0${index % 9}:00` });
  }
  if (['已绑定', '已发货', '已退货'].includes(status)) {
    history.push({ action: '绑定CPUID', time: `2026-08-2${index % 9} 14:3${index % 9}:00`, cpu_id: `CPU${String(1000 + index)}` });
  }
  if (['已发货', '已退货'].includes(status)) {
    history.push({ action: '发货', time: `2026-08-2${index % 9} 16:0${index % 9}:00` });
  }
  if (status === '已退货') {
    history.push({ action: '退货', time: `2026-08-2${index % 9} 18:0${index % 9}:00` });
  }
  return history;
};

export const MOCK_SERIAL_LIST = {
  code: 0,
  message: "success",
  data: {
    total: 40,
    list: Array.from({ length: 40 }).map((_, index) => {
      // 状态（6 循环）：已绑定 / 已授权(下发) / 已发货 / 已退货 / 未使用(已分配工单) / 未使用(在库)
      const SERIAL_STATUS = ['已绑定', '已授权(下发)', '已发货', '已退货', '未使用', '未使用'];
      const m = index % 6;
      const hasOrder = m !== 5;
      const orderStatus = ORDER_STATUS[(index % 10) % 4];
      let status = SERIAL_STATUS[m];
      // 待生产工单的串码均为未使用
      if (hasOrder && orderStatus === '待生产') {
        status = '未使用';
      }
      const isBound = ['已绑定', '已发货', '已退货'].includes(status);
      const isIssued = status !== '未使用';
      const isShipped = ['已发货', '已退货'].includes(status);
      const isReturned = status === '已退货';
      const platform = PLATFORMS[index % 4];
      const model = MODELS[index % 4];
      const macStep = MODEL_MAC_STEP[model] || 1;
      const macBase = 0x09B8AB + index * 4;
      const macs = Array.from({ length: macStep }).map((_, k) => `E0DCA0${(macBase + k).toString(16).padStart(6, '0').toUpperCase()}`);
      return {
        id: `${index + 1}`,
        sn: `SN${String(2026000001 + index)}`,
        mac: macs.join('\n'),
        platform,
        fields: genPlatformFields(platform, index),
        model,
        factory: FACTORIES[index % 3],
        order_no: hasOrder ? `PO2026080${(index % 10) + 1}` : '',
        purpose: hasOrder ? ['研发', '试产', '量产PO', '售后'][index % 4] : '',
        status,
        cpu_id: isBound ? `CPU${String(1000 + index)}` : '',
        issue_time: isIssued ? `2026-08-1${index % 9} 14:0${index % 9}:00` : '',
        bind_time: isBound ? `2026-08-1${index % 9} 14:3${index % 9}:00` : '',
        ship_time: isShipped ? `2026-08-2${index % 9} 16:0${index % 9}:00` : '',
        return_time: isReturned ? `2026-08-2${index % 9} 18:0${index % 9}:00` : '',
        import_time: "2026-08-19 10:00:00",
        history: genSerialHistory(status, index)
      };
    })
  }
};

// ============ 串码资源（可变 store：作废后从列表移除，进入作废记录） ============
const serialStore = MOCK_SERIAL_LIST.data.list;

const voidStore = [
  { id: 'v1', sn: 'SN2026000100', mac: '', fields: { CTEI: '860000000000100', UID: 'UID800100', KEY1: 'KEY1100', KEY2: 'KEY2100' }, platform: '电信', void_time: '2026-08-15 10:20:00', void_type: '导入格式错误' },
  { id: 'v2', sn: 'SN2026000101', mac: '', fields: { CMEI: '860000000000101', SN: '86000000000000000101', KEY: 'KEY100' }, platform: '移动', void_time: '2026-08-16 14:05:00', void_type: '重复导入' },
  { id: 'v3', sn: 'SN2026000102', mac: 'E0DCA0000003', fields: { CUEI: '860000000000102' }, platform: '联通', void_time: '2026-08-18 09:40:00', void_type: '手动作废' },
];

const unbindStore = [
  { id: 'u1', sn: 'SN2026000200', mac: 'E0DCA0000101', cpu_id: 'CPU2001', uid: 'UID800200', fields: { CTEI: '860000000000200', UID: 'UID800200', KEY1: 'KEY1200', KEY2: 'KEY2200' }, order_no: 'PO20260801', purpose: '研发', factory: '达天', model: 'YLF-X1', unbind_time: '2026-08-12 09:30:00', operator: 'admin' },
  { id: 'u2', sn: 'SN2026000201', mac: 'E0DCA0000102', cpu_id: 'CPU2002', uid: 'UID800201', fields: { CMEI: '860000000000201', SN: '86000000000000000201', KEY: 'KEY201' }, order_no: 'PO20260802', purpose: '试产', factory: '凯木金', model: 'YLF-G2', unbind_time: '2026-08-13 11:00:00', operator: 'admin' },
];

const resetStore = [
  { id: 'r1', sn: 'SN2026000300', mac: 'E0DCA0000201', fields: { CTEI: '860000000000300', UID: 'UID800300', KEY1: 'KEY1300', KEY2: 'KEY2300' }, before_status: '已授权(下发)', order_no: 'PO20260803', purpose: '量产PO', factory: '中嘉', model: 'YLF-C3', reset_time: '2026-08-14 10:00:00', operator: 'admin' },
  { id: 'r2', sn: 'SN2026000301', mac: 'E0DCA0000202', fields: { CMEI: '860000000000301', SN: '86000000000000000301', KEY: 'KEY301' }, before_status: '已绑定', order_no: 'PO20260804', purpose: '售后', factory: '达天', model: 'YLF-T4', reset_time: '2026-08-15 15:30:00', operator: 'admin' },
];

export function getSerialListData(params = {}) {
  let list = serialStore;
  if (params.order_no) {
    const order = MOCK_ORDER_LIST.data.list.find((o) => o.order_no === params.order_no);
    if (order && order.status === '已关闭') {
      return { code: 0, message: "success", data: { total: 0, list: [] } };
    }
    list = list.filter((s) => s.order_no === params.order_no);
  }
  if (params.mac) list = list.filter((s) => (s.mac || '').toLowerCase().includes(String(params.mac).toLowerCase()));
  if (params.sn) list = list.filter((s) => (s.sn || '').toLowerCase().includes(String(params.sn).toLowerCase()));
  if (params.platform) list = list.filter((s) => s.platform === params.platform);
  if (params.query_field && params.query_value) {
    const v = String(params.query_value).trim().toLowerCase();
    list = list.filter((s) => String(s.fields?.[params.query_field] ?? '').toLowerCase().includes(v));
  }
  if (params.key_value) {
    const v = String(params.key_value).trim().toLowerCase();
    list = list.filter((s) => {
      const kf = getPlatformKeyField(s.platform);
      return String((kf && s.fields?.[kf]) ?? '').toLowerCase().includes(v);
    });
  }
  if (params.factory) list = list.filter((s) => s.factory === params.factory);
  if (params.model) list = list.filter((s) => s.model === params.model);
  if (params.auth_status) {
    if (params.auth_status === '未授权') list = list.filter((s) => s.status === '未使用');
    else list = list.filter((s) => s.status !== '未使用');
  }
  if (params.bind_status) {
    const bound = ['已绑定', '已发货', '已退货'];
    if (params.bind_status === '未绑定') list = list.filter((s) => !bound.includes(s.status));
    else list = list.filter((s) => bound.includes(s.status));
  }
  if (params.logistics_status) {
    const shipped = ['已发货', '已退货'];
    if (params.logistics_status === '未发货') list = list.filter((s) => !shipped.includes(s.status));
    else list = list.filter((s) => s.status === params.logistics_status);
  }
  if (params.date_range && params.date_range[0] && params.date_range[1]) {
    const field = params.time_type || 'issue_time';
    const [start, end] = params.date_range;
    list = list.filter((s) => {
      const t = s[field] || '';
      if (!t) return false;
      const date = t.slice(0, 10);
      return date >= start && date <= end;
    });
  }
  // 字段级权限：按当前会话角色裁剪字段（模拟后端只返回可见列）
  const hiddenFields = getSessionHiddenFields();
  const hiddenSet = new Set(hiddenFields['serial:list'] || []);
  list = list.map((row) => pruneRowFields(row, 'serial:list', hiddenSet));
  return { code: 0, message: "success", data: { total: list.length, list: list.slice() } };
}

export function voidSerial(id) {
  const idx = serialStore.findIndex((s) => s.id === String(id));
  if (idx !== -1) {
    const [removed] = serialStore.splice(idx, 1);
    voidStore.unshift({
      id: removed.id,
      sn: removed.sn,
      mac: removed.mac,
      fields: removed.fields,
      platform: removed.platform,
      void_time: "2026-08-19 16:00:00",
      void_type: '手动作废'
    });
  }
  return { code: 0, message: "操作成功", data: {} };
}

export function resetSerialAuth(id) {
  const item = serialStore.find((s) => s.id === String(id));
  if (item) {
    resetStore.unshift({
      id: `r${Date.now()}`,
      sn: item.sn,
      mac: item.mac,
      fields: item.fields,
      before_status: item.status,
      order_no: item.order_no,
      purpose: item.purpose,
      factory: item.factory,
      model: item.model,
      reset_time: "2026-08-19 17:00:00",
      operator: 'admin'
    });
    item.status = '未使用';
    item.cpu_id = '';
    item.issue_time = '';
    item.bind_time = '';
  }
  return { code: 0, message: "操作成功", data: {} };
}

export function unbindSerialCpu(id) {
  const item = serialStore.find((s) => s.id === String(id));
  if (item) {
    unbindStore.unshift({
      id: `u${Date.now()}`,
      sn: item.sn,
      mac: item.mac,
      cpu_id: item.cpu_id,
      uid: item.fields?.UID || '',
      fields: item.fields,
      order_no: item.order_no,
      purpose: item.purpose,
      factory: item.factory,
      model: item.model,
      unbind_time: "2026-08-19 17:00:00",
      operator: 'admin'
    });
    item.status = '已授权(下发)';
    item.cpu_id = '';
    item.bind_time = '';
  }
  return { code: 0, message: "操作成功", data: {} };
}

export function getUnbindRecordsData(params = {}) {
  let list = unbindStore;
  if (params.sn) list = list.filter((r) => (r.sn || '').toLowerCase().includes(String(params.sn).toLowerCase()));
  if (params.mac) list = list.filter((r) => (r.mac || '').toLowerCase().includes(String(params.mac).toLowerCase()));
  return { code: 0, message: "success", data: { total: list.length, list: pruneListRows(list.slice(), 'serial:unbind-records') } };
}

export function getResetRecordsData(params = {}) {
  let list = resetStore;
  if (params.sn) list = list.filter((r) => (r.sn || '').toLowerCase().includes(String(params.sn).toLowerCase()));
  if (params.mac) list = list.filter((r) => (r.mac || '').toLowerCase().includes(String(params.mac).toLowerCase()));
  return { code: 0, message: "success", data: { total: list.length, list: pruneListRows(list.slice(), 'serial:reset-records') } };
}

export function getVoidRecordsData() {
  return { code: 0, message: "success", data: { total: voidStore.length, list: pruneListRows(voidStore.slice(), 'serial:void-records') } };
}

// ============ 导入记录 ============
export const MOCK_IMPORT_RECORDS = {
  code: 0,
  message: "success",
  data: {
    total: 8,
    list: Array.from({ length: 8 }).map((_, index) => ({
      id: `${index + 1}`,
      file_name: `串码导入_${PLATFORMS[index % 4]}_2026080${index + 1}.xlsx`,
      operator: index % 2 === 0 ? 'admin' : 'operator01',
      import_time: `2026-08-0${index + 1} 10:3${index % 9}:00`,
      total: 1000,
      success: 1000 - index * 3,
      fail: index * 3,
      platform: PLATFORMS[index % 4],
      void_type: index % 2 === 0 ? '导入格式错误' : '重复导入'
    }))
  }
};

export function getImportRecordsData() {
  return { code: 0, message: "success", data: { total: MOCK_IMPORT_RECORDS.data.total, list: pruneListRows(MOCK_IMPORT_RECORDS.data.list.slice(), 'serial:import-records') } };
}

// ============ 生产工单 ============
export const MOCK_ORDER_LIST = {
  code: 0,
  message: "success",
  data: {
    total: 15,
    list: Array.from({ length: 10 }).map((_, index) => {
      const quantity = (index + 1) * 100;
      const status = ORDER_STATUS[index % 4];
      let allocated = quantity;
      let authorized = 0;
      let bound = 0;
      let shipped = 0;
      let returned = 0;
      if (status === '已关闭') {
        allocated = 0;
      } else if (status === '待生产') {
        allocated = Math.floor(quantity * 0.4);
      } else if (status === '生产中') {
        authorized = Math.floor(quantity * 0.4);
        bound = Math.floor(quantity * 0.2);
        shipped = Math.floor(quantity * 0.1);
      } else if (status === '已完成') {
        bound = Math.floor(quantity * 0.3);
        shipped = Math.floor(quantity * 0.5);
        returned = Math.floor(quantity * 0.2);
      }
      return {
        id: `${index + 1}`,
        order_no: `PO2026080${index + 1}`,
        remark: ['', '加急生产', '', '客户定制'][index % 4],
        purpose: ['研发', '试产', '量产PO', '售后'][index % 4],
        factory: FACTORIES[index % 3],
        platform: PLATFORMS[index % 4],
        model: MODELS[index % 4],
        quantity,
        allocated,
        authorized,
        bound,
        shipped,
        returned,
        status,
        creator: 'admin',
        create_time: `2026-08-1${index % 9} 09:00:00`
      };
    })
  }
};

// ============ 工单数据（含字段级裁剪） ============
export function getOrderListData() {
  const hiddenFields = getSessionHiddenFields();
  const hiddenSet = new Set(hiddenFields['order:list'] || []);
  return {
    code: 0,
    message: "success",
    data: {
      total: MOCK_ORDER_LIST.data.total,
      list: MOCK_ORDER_LIST.data.list.map((row) => pruneRowFields(row, 'order:list', hiddenSet))
    }
  };
}

// ============ 异常告警 ============
export const MOCK_ALERT_LIST = {
  code: 0,
  message: "success",
  data: {
    total: 6,
    list: Array.from({ length: 6 }).map((_, index) => ({
      id: `${index + 1}`,
      type: index % 2 === 0 ? '重复授权请求' : 'CPUID绑定冲突',
      mac: `E0DCA0${(0x09B8AB + index).toString(16).padStart(6, '0').toUpperCase()}`,
      sn: `SN${String(2026000001 + index)}`,
      order_no: `PO2026080${index + 1}`,
      cpu_id: `CPU${String(1000 + index)}`,
      email: 'alarm@ylf.com',
      time: `2026-08-1${index % 9} 15:2${index % 9}:00`,
      status: index % 3 === 0 ? '待发送' : '已发送'
    }))
  }
};

export function getAlertListData() {
  return { code: 0, message: "success", data: { total: MOCK_ALERT_LIST.data.total, list: pruneListRows(MOCK_ALERT_LIST.data.list.slice(), 'auth:alerts') } };
}

// ============ 运营平台配置 ============
export const MOCK_PLATFORM_LIST = {
  code: 0,
  message: "success",
  data: {
    list: [
      { id: '1', name: '电信', code: 'telecom', fields: [
        { name: 'CTEI', lengths: [15, 26], is_key: false }, { name: 'UID', lengths: [32], is_key: false },
        { name: 'KEY1', lengths: [16], is_key: true }, { name: 'KEY2', lengths: [16], is_key: false }], status: '启用' },
      { id: '2', name: '移动', code: 'mobile', fields: [
        { name: 'CMEI', lengths: [15], is_key: false }, { name: 'SN', lengths: [20], is_key: false }, { name: 'KEY', lengths: [16], is_key: true }], status: '启用' },
      { id: '3', name: '联通', code: 'unicom', fields: [
        { name: 'CUEI', lengths: [15], is_key: false }], status: '启用' },
      { id: '4', name: '涂鸦', code: 'tuya', fields: [
        { name: 'UID', lengths: [32], is_key: false }, { name: 'KEY', lengths: [16], is_key: true }], status: '启用' },
    ]
  }
};

// ============ MAC 规则 ============
export const MOCK_MAC_RULE = {
  code: 0,
  message: "success",
  data: {
    prefix: 'E0DCA0',
    start: '09B8AB',
    end: '0A0000',
    current: 4668
  }
};

// ============ 设备型号（按平台） ============
const modelStore = {
  '电信': [
    { id: 'm1', name: 'YLF-X1', type: '网关', status: '启用', mac_step: 2 },
    { id: 'm2', name: 'YLF-G2', type: '模组', status: '启用', mac_step: 1 },
    { id: 'm3', name: 'YLF-C3', type: '传感器', status: '停用', mac_step: 3 },
  ],
  '移动': [
    { id: 'm4', name: 'YLF-X1', type: '网关', status: '启用', mac_step: 2 },
    { id: 'm5', name: 'YLF-G2', type: '模组', status: '停用', mac_step: 1 },
  ],
  '联通': [
    { id: 'm6', name: 'YLF-C3', type: '传感器', status: '启用', mac_step: 3 },
  ],
  '涂鸦': [
    { id: 'm7', name: 'YLF-T4', type: '网关', status: '启用', mac_step: 1 },
    { id: 'm8', name: 'YLF-X1', type: '网关', status: '停用', mac_step: 2 },
  ],
};

export function getPlatformListData() {
  const list = MOCK_PLATFORM_LIST.data.list.map((p) => ({
    ...p,
    model_enabled_count: (modelStore[p.name] || []).filter((m) => m.status === '启用').length,
  }));
  return { code: 0, message: "success", data: { list } };
}

// 平台 -> 密钥字段名
export function getPlatformKeyField(platform) {
  const p = MOCK_PLATFORM_LIST.data.list.find((x) => x.name === platform);
  return p ? (p.fields.find((f) => f.is_key) || {}).name : '';
}

export function getModelListData(platform) {
  return { code: 0, message: "success", data: { list: modelStore[platform] || [] } };
}

export function saveModelData(platform, data) {
  const list = modelStore[platform] || (modelStore[platform] = []);
  if (data.id) {
    const item = list.find((m) => m.id === data.id);
    if (item) {
      item.name = data.name;
      item.type = data.type;
      if (data.status) item.status = data.status;
      item.mac_step = data.mac_step ?? item.mac_step ?? 1;
    }
  } else {
    list.push({ id: `m${Date.now()}`, name: data.name, type: data.type, status: data.status || '启用', mac_step: data.mac_step ?? 1 });
  }
  return { code: 0, message: "操作成功", data: {} };
}

export function updateModelStatus(platform, id, status) {
  const list = modelStore[platform] || [];
  const item = list.find((m) => m.id === id);
  if (item) item.status = status;
  return { code: 0, message: "操作成功", data: {} };
}

// ============ 工厂 ============
export const MOCK_FACTORY_LIST = {
  code: 0,
  message: "success",
  data: {
    list: [
      { id: '1', name: '达天', code: 'DT', contact: '张工', phone: '13800000001', status: '启用' },
      { id: '2', name: '凯木金', code: 'KMJ', contact: '李工', phone: '13800000002', status: '启用' },
      { id: '3', name: '中嘉', code: 'ZJ', contact: '王工', phone: '13800000003', status: '启用' },
    ]
  }
};

// ============ 账户与权限 ============
export const MOCK_ACCOUNT_LIST = {
  code: 0,
  message: "success",
  data: {
    list: [
      { id: '1', username: 'admin', nickname: '管理员', role: '管理员', status: '启用', create_time: '2026-07-01 09:00:00' },
      { id: '2', username: 'operator01', nickname: '运营人员', role: '运营', status: '启用', create_time: '2026-07-05 10:00:00' },
      { id: '3', username: 'viewer01', nickname: '只读用户', role: '访客', status: '停用', create_time: '2026-07-10 11:00:00' },
    ]
  }
};

// ============ 角色管理 ============
const roleStore = [
  { id: '1', name: '管理员', code: 'admin', desc: '超级管理员，拥有全部权限', is_builtin: true, codes: [], hidden_fields: {}, create_time: '2026-07-01 09:00:00' },
  { id: '2', name: '运营', code: 'operator', desc: '负责串码下发与工单管理', is_builtin: false, codes: ['serial:list', 'serial:import', 'serial:export', 'serial:detail', 'serial:unbind', 'serial:reset', 'serial:void', 'order:list', 'order:create', 'order:edit', 'order:serial', 'order:export'], hidden_fields: { 'serial:list': ['key', 'bind_time'], 'order:list': ['remark'] }, create_time: '2026-07-05 10:00:00' },
  { id: '3', name: '访客', code: 'viewer', desc: '只读访问', is_builtin: false, codes: ['serial:list', 'serial:detail', 'order:list', 'order:serial'], hidden_fields: { 'serial:list': ['key', 'cpu_id', 'issue_time', 'bind_time', 'fields'], 'order:list': ['factory', 'remark', 'creator'] }, create_time: '2026-07-10 11:00:00' },
];

export function getRoleListData() {
  return { code: 0, message: "success", data: { list: roleStore.slice() } };
}

export function saveRoleData(data) {
  if (data.id) {
    const item = roleStore.find((r) => r.id === String(data.id));
    if (item) {
      item.name = data.name;
      item.desc = data.desc || '';
      item.codes = data.codes || [];
      item.hidden_fields = data.hidden_fields || {};
    }
  } else {
    roleStore.push({
      id: `${Date.now()}`,
      name: data.name,
      code: `role_${Date.now()}`,
      desc: data.desc || '',
      is_builtin: false,
      codes: data.codes || [],
      hidden_fields: data.hidden_fields || {},
      create_time: '2026-08-25 10:00:00'
    });
  }
  return { code: 0, message: "操作成功", data: {} };
}

export function deleteRoleData(id) {
  const idx = roleStore.findIndex((r) => r.id === String(id));
  if (idx !== -1) roleStore.splice(idx, 1);
  return { code: 0, message: "操作成功", data: {} };
}

// ============ 登录会话（mock 模拟后端按角色裁剪数据） ============
let sessionRole = '管理员';

export function loginUser(username) {
  const account = MOCK_ACCOUNT_LIST.data.list.find((a) => a.username === username);
  const roleName = account ? account.role : '管理员';
  sessionRole = roleName;
  const role = roleStore.find((r) => r.name === roleName);
  const isBuiltin = role ? role.is_builtin : true;
  return {
    role: roleName,
    is_admin: isBuiltin,
    codes: isBuiltin ? ALL_CODES : (role ? role.codes : []),
    hidden_fields: isBuiltin ? {} : (role ? (role.hidden_fields || {}) : {}),
  };
}

// 当前会话角色的字段隐藏集（黑名单）
export function getSessionHiddenFields() {
  const role = roleStore.find((r) => r.name === sessionRole);
  if (!role || role.is_builtin) return {};
  return role.hidden_fields || {};
}

// 按字段权限裁剪一行数据（模拟后端只返回可见列；必显字段不裁剪）
function pruneRowFields(row, listCode, hiddenSet) {
  const fields = getFieldMap()[listCode] || [];
  const out = { ...row };
  fields.forEach((f) => {
    if (!f.required && hiddenSet.has(f.code) && f.code in out) delete out[f.code];
  });
  return out;
}

// 按字段权限裁剪一组数据
function pruneListRows(rows, listCode) {
  const hidden = getSessionHiddenFields();
  const hiddenSet = new Set(hidden[listCode] || []);
  return rows.map((row) => pruneRowFields(row, listCode, hiddenSet));
}

// ============ 发货报盘 ============
const shipmentStore = [
  { id: 's1', file_name: '发货报盘_20260820.xlsx', operator: 'admin', time: '2026-08-20 15:30:00', total: 200, success: 200, fail: 0 },
  { id: 's2', file_name: '发货报盘_20260821.xlsx', operator: 'admin', time: '2026-08-21 10:00:00', total: 150, success: 148, fail: 2 },
  { id: 's3', file_name: '发货报盘_20260822.xlsx', operator: 'operator01', time: '2026-08-22 16:45:00', total: 300, success: 295, fail: 5 },
];

// 发货报盘：批量把「已绑定」串码置为「已发货」
// data: { file_name, rows: [{ sn, mac, order_no }] }
export function shipmentDeclare(data) {
  const rows = (data && data.rows) || [];
  const file_name = (data && data.file_name) || '发货报盘.xlsx';
  const results = [];
  let success = 0;
  let fail = 0;

  rows.forEach((row) => {
    const sn = String(row.sn || '').trim();
    const mac = String(row.mac || '').trim();
    const orderNo = String(row.order_no || '').trim();
    const base = { sn, mac, order_no: orderNo };

    if (!sn) {
      results.push({ ...base, status: '失败', message: 'SN 为空' });
      fail++;
      return;
    }
    const item = serialStore.find((s) => s.sn === sn);
    if (!item) {
      results.push({ ...base, status: '失败', message: '串码不存在' });
      fail++;
      return;
    }
    if (mac && !(item.mac || '').split('\n').map((x) => x.trim()).includes(mac)) {
      results.push({ ...base, status: '失败', message: 'SN 与 MAC 不匹配' });
      fail++;
      return;
    }
    if (orderNo && item.order_no !== orderNo) {
      results.push({ ...base, status: '失败', message: 'SN 与工单号不匹配' });
      fail++;
      return;
    }
    if (item.status === '已发货') {
      results.push({ ...base, status: '失败', message: '已发货，重复报盘' });
      fail++;
      return;
    }
    if (item.status === '已退货') {
      results.push({ ...base, status: '失败', message: '已退货，不可发货' });
      fail++;
      return;
    }
    if (item.status !== '已绑定') {
      results.push({ ...base, status: '失败', message: '当前状态不可发货，需先绑定' });
      fail++;
      return;
    }

    const shipTime = '2026-08-25 10:30:00';
    item.status = '已发货';
    if (!item.history) item.history = [];
    item.history.push({ action: '发货', time: shipTime });
    results.push({ ...base, status: '成功', message: '发货成功' });
    success++;
  });

  shipmentStore.unshift({
    id: `s${Date.now()}`,
    file_name,
    operator: 'admin',
    time: '2026-08-25 10:30:00',
    total: rows.length,
    success,
    fail
  });

  return { code: 0, message: "success", data: { total: rows.length, success, fail, list: results } };
}

export function getShipmentRecordsData() {
  return { code: 0, message: "success", data: { total: shipmentStore.length, list: pruneListRows(shipmentStore.slice(), 'serial:shipment-records') } };
}

// ============ 退货 ============
const returnStore = [
  { id: 't1', file_name: '退货_20260821.xlsx', operator: 'admin', time: '2026-08-21 14:20:00', total: 50, success: 50, fail: 0 },
  { id: 't2', file_name: '退货_20260822.xlsx', operator: 'operator01', time: '2026-08-22 11:10:00', total: 80, success: 77, fail: 3 },
];

// 退货：批量把「已发货」串码置为「已退货」
// data: { file_name, rows: [{ sn, mac, order_no }] }
export function returnDeclare(data) {
  const rows = (data && data.rows) || [];
  const file_name = (data && data.file_name) || '退货.xlsx';
  const results = [];
  let success = 0;
  let fail = 0;

  rows.forEach((row) => {
    const sn = String(row.sn || '').trim();
    const mac = String(row.mac || '').trim();
    const orderNo = String(row.order_no || '').trim();
    const base = { sn, mac, order_no: orderNo };

    if (!sn) {
      results.push({ ...base, status: '失败', message: 'SN 为空' });
      fail++;
      return;
    }
    const item = serialStore.find((s) => s.sn === sn);
    if (!item) {
      results.push({ ...base, status: '失败', message: '串码不存在' });
      fail++;
      return;
    }
    if (mac && !(item.mac || '').split('\n').map((x) => x.trim()).includes(mac)) {
      results.push({ ...base, status: '失败', message: 'SN 与 MAC 不匹配' });
      fail++;
      return;
    }
    if (orderNo && item.order_no !== orderNo) {
      results.push({ ...base, status: '失败', message: 'SN 与工单号不匹配' });
      fail++;
      return;
    }
    if (item.status === '已退货') {
      results.push({ ...base, status: '失败', message: '已退货，重复退货' });
      fail++;
      return;
    }
    if (item.status !== '已发货') {
      results.push({ ...base, status: '失败', message: '状态不是已发货' });
      fail++;
      return;
    }

    const returnTime = '2026-08-25 15:00:00';
    item.status = '已退货';
    if (!item.history) item.history = [];
    item.history.push({ action: '退货', time: returnTime });
    results.push({ ...base, status: '成功', message: '退货成功' });
    success++;
  });

  returnStore.unshift({
    id: `t${Date.now()}`,
    file_name,
    operator: 'admin',
    time: '2026-08-25 15:00:00',
    total: rows.length,
    success,
    fail
  });

  return { code: 0, message: "success", data: { total: rows.length, success, fail, list: results } };
}

export function getReturnRecordsData() {
  return { code: 0, message: "success", data: { total: returnStore.length, list: pruneListRows(returnStore.slice(), 'serial:return-records') } };
}

// ============ 通知邮件配置 ============
const notifyConfigStore = {
  provider: 'qq',
  sender_email: 'no-reply@qq.com',
  sender_name: '易莱孚',
  smtp_host: 'smtp.qq.com',
  smtp_port: 465,
  ssl: true,
  auth_code: 'mock_auth_code',
  repeat_recipients: ['alarm@qq.com'],
  conflict_recipients: ['alarm@163.com'],
};

export function getNotifyConfigData() {
  return { code: 0, message: "success", data: { ...notifyConfigStore } };
}

export function saveNotifyConfigData(data) {
  Object.assign(notifyConfigStore, data);
  return { code: 0, message: "操作成功", data: {} };
}

export function testNotifyData() {
  return { code: 0, message: "测试邮件发送成功", data: {} };
}
